import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackNavigation } from '@/lib/sentry';

export const NavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    let previousPath = '/';
    
    return () => {
      if (previousPath !== location.pathname) {
        trackNavigation(previousPath, location.pathname);
        previousPath = location.pathname;
      }
    };
  }, [location]);

  return null;
};